import { Composite } from '@interfaces/composite/1.0';
import { Observable } from 'rxjs';

export abstract class AbstractCompositeService {
  abstract getComposites(brandId: string): Observable<Composite[]>;

  abstract save(
    catalogEntryId: string,
    composite: Composite,
    remove?: string[],
  ): Observable<Composite>;

  abstract create(composite: Composite, brandId: string): Observable<Composite>;
}
